import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Row,
  Column,
  FooterLink,
  Heading,
} from "./FooterStyles.js";

const Footer = () => {
  return (
    <Box>
      <h1
        style={{ color: "green", textAlign: "center", marginTop: "-50px" }}
      ></h1>
      <Container>
        <Row>
          <Column>
            <Heading>About me</Heading>
            <Link style={{ textDecoration: "none" }} to="./About">
              {" "}
              <FooterLink href="#">Aim</FooterLink>
            </Link>
            <br />
            <FooterLink href="https://drive.google.com/file/d/1IsPG9KgP90PvmVyMNqaBSQEVyivAUEb9/view?usp=sharing">
              My Resume
            </FooterLink>
          </Column>
          <Column>
            <Heading>Hit me up on &#9993;</Heading>
            <FooterLink href="https://www.linkedin.com/in/ahmed-towsik/">
              <i className="fab fa-linkedin">
                <span style={{ marginLeft: "10px", color: "#668cff" }}>
                  LinkedIn
                </span>
              </i>
            </FooterLink>
            <FooterLink href="https://www.facebook.com/ahmed.towsik.7">
              <i className="fab fa-facebook-f">
                <span style={{ marginLeft: "10px", color: "#0080ff" }}>
                  Facebook
                </span>
              </i>
            </FooterLink>
            <FooterLink href="https://www.instagram.com/_man.stop/">
              <i className="fab fa-instagram">
                <span style={{ marginLeft: "10px", color: "#f20d46" }}>
                  Instagram
                </span>
              </i>
            </FooterLink>
          </Column>
        </Row>
      </Container>
    </Box>
  );
};
export default Footer;
